// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navbarleft_wrapper__DAkDU"};